import { render, staticRenderFns } from "./Exception.vue?vue&type=template&id=a5a1fb0c&scoped=true&"
import script from "./Exception.vue?vue&type=script&lang=ts&"
export * from "./Exception.vue?vue&type=script&lang=ts&"
import style0 from "./Exception.vue?vue&type=style&index=0&id=a5a1fb0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a1fb0c",
  null
  
)

export default component.exports